import { Component, OnInit } from '@angular/core';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { CorspdcService } from 'app/services/corspdc.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-batch',
  templateUrl: './batch.component.html',
  styleUrls: ['./batch.component.css']
})
export class BatchComponent implements OnInit {

  batches = [];
  batch:any = {};
  direction: boolean = false;
  criteria = "DateSubmitted";  
  isLoading: Boolean = false;
  message: string = 'Loading  correspondence batches, please wait...';  
  currentPage = 1;
  isEmpty: boolean = false;
  pageSize: number = 10;
  count: number = 0;


  constructor(public utility: UtilityServiceService, private corspdcService: CorspdcService, private router: Router, private toastr: ToastrService) { }

  ngOnInit() {    
    this.loadBatches();
    this.utility.initTooltip();
  }

  onNextOrPrevious(page: number = 1) {
    this.message = 'Loading  correspondence batches, please wait...';    
    this.loadBatches(page, this.pageSize);
    this.currentPage = page;
    return page;
  }

  loadBatches(page: number = 1, pageSize: number = 10): void {
    this.message = 'Loading  correspondence batches, please wait...'; 
    this.isLoading = true;
    this.corspdcService.listBatches(page, pageSize).subscribe((result:any) => {
      this.batches = result.Batches;
      this.count = result.Count;
      this.isEmpty = (this.count == 0) ? true : false;     
      this.isLoading = false;      
    }, error => {
      this.batches = [];
      this.isEmpty = true;
      //console.log('Error occured: ' + error);
      this.isLoading = false;
    });
  }

  closeBatches = () => {
    this.router.navigateByUrl('/corspdc/list');
  }

  send = () => {
    this.isLoading = true;
    this.message = "Sending correspondences, please wait...";
    this.corspdcService.runSend().subscribe((result:any) => {
      this.batch = result.Batch;     
      if (this.batch == null) {
        this.toastr.info(`No correspondences to send available. `, 'Sending Correspondences');
      }
      else {
        this.toastr.success(` ${this.batch.num_emails_sent} email(s) and ${this.batch.num_sms_sent} SMS(s) sent.`, 'Sending Correspondences');
        this.loadBatches();
      }       
      this.isLoading = false;
    }, error => {      
      //console.log('Error occured: ' + error);
      this.isLoading = false;
    });
  }

  onChange = () => {
    this.loadBatches(this.utility.page = 1, this.pageSize);
  }

}
